import { MatHorizontalStepper } from '@angular/material';

export abstract class StepperServiceVM {
    abstract configure(stepper: MatHorizontalStepper): void;

    abstract get currentStep(): number;

    abstract nextStep(): void;
}
